module.exports = __webpack_public_path__ + "img/music-plaza.60e69c5b.webp";